export default __webpack_public_path__ + "static/media/01.d8d2a44a.jpg";